/** Usage CPU et mémoire (ADR 0053, 2026-10-10). Branché dans `fr.ts` sous `resourceUsage`. */
export const resourceUsageFr = {
  tab: 'Usage',
  help: 'CPU et mémoire de la dernière heure, relevés toutes les 30 s sur le cluster et sommés sur les pods.',
  metrics: {
    cpu: 'CPU (cœurs)',
    memory: 'Mémoire (Mio)',
  },
} as const;
